<template>
  <admin-wrapper
    ref="water-balance-settings-admin-wrapper"
    :has-buttons="inputs.length ? true : false"
    :inputs="inputs"
    :is-form-fetched="isFetched"
    :is-custom-saving="saving"
    title-translation-path="admin.WATER_BALANCE_MODULE"
    :moduleEnabler="moduleEnabler"
    @save="save"
  >
    <template #[`balanceProfile.input`]="data">
      <v-col cols="3">
        <data-input v-bind="data" v-model="balanceProfile" />
      </v-col>
    </template>
    <template #[`iwaProfile.input`]="data">
      <v-col cols="3">
        <data-input v-bind="data" v-model="iwaProfile" />
      </v-col>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';

export default {
  name: 'WaterBalanceSettings',
  components: {
    AdminWrapper,
    DataInput,
  },
  data: () => ({
    balanceProfie: null,
    iwaProfile: null,
    isFormFetched: false,
    isFetched: false,
    saving: false,
  }),
  computed: {
    defaultBalanceProfile: get('waterBalance/defaultBalanceProfile'),
    defaultIwaProfile: get('waterBalance/defaultIwaProfile'),
    waterBalanceModuleEnabled: get('admin/settingsValues@water_balance_module_enabled'),
    waterBalanceBalanceEnabled: get('admin/settingsValues@water_balance_balance_enabled'),
    waterBalanceIwaEnabled: get('admin/settingsValues@water_balance_iwa_enabled'),

    balanceProfiles: get('waterBalance/balanceProfiles'),
    iwaProfiles: get('waterBalance/iwaProfiles'),

    inputs() {
      if (!this.waterBalanceModuleEnabled) {
        return [];
      }
      const inputs = [];
      if (this.waterBalanceBalanceEnabled) {
        inputs.push({
          name: 'balanceProfile',
          translationPath: 'admin.waterBalanceDefaultProfile',
          rules: [v => !!v || v == '0' || 'rules.required'],
          dataType: {
            name: 'select',
          },
          align: 'start',
          items: this.balanceProfiles,
          itemText: 'name',
          itemValue: 'id',
          isCustom: true,
          disabled: this.saving,
        });
      }
      if (this.waterBalanceIwaEnabled) {
        inputs.push({
          name: 'iwaProfile',
          translationPath: 'admin.waterBalanceIwaDefaultProfile',
          rules: [v => !!v || v == '0' || 'rules.required'],
          dataType: {
            name: 'select',
          },
          align: 'start',
          items: this.iwaProfiles,
          itemText: 'name',
          itemValue: 'id',
          isCustom: true,
          disabled: this.saving,
        });
      }
      return inputs;
    },
    moduleEnabler() {
      return {
        name: 'water_balance_module_enabled',
        translationPath: 'admin.WATER_BALANCE_MODULE',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.WATER_BALANCE_MODULE') }),
      };
    },
  },
  methods: {
    getBalanceProfiles: call('waterBalance/getBalanceProfiles'),
    getIwaProfiles: call('waterBalance/getIwaProfiles'),

    setDefaultBalanceProfile: call('waterBalance/setDefaultBalanceProfile'),
    setDefaultIwaProfile: call('waterBalance/setDefaultIwaProfile'),

    async init() {
      try {
        const promises = this.inputs.map(input => {
          return this[`get${this.$_capitalize(input.name)}s`]();
        });
        await Promise.all(promises);
        this.inputs.forEach(input => {
          this[input.name] = this[`default${this.$_capitalize(input.name)}`] || null;
        });
        this.isFetched = true;
        this.$nextTick(() => {
          this.$refs['water-balance-settings-admin-wrapper']?.$refs.form?.$refs.form?.resetValidation();
        });
      } catch {
        //
      }
    },
    async save() {
      try {
        this.saving = true;
        const promises = this.inputs.map(input => {
          const inputName = input.name;
          return this[inputName] === this[`default${this.$_capitalize(inputName)}`]
            ? undefined
            : this[`setDefault${this.$_capitalize(inputName)}`](this[inputName]);
        });
        const filterPromises = promises.filter(promise => !!promise);
        await Promise.all(filterPromises);
        if (filterPromises.length) {
          await this.init();
        }
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successEditSetting'),
        });
        this.saving = false;
      } catch {
        this.saving = false;
      }
    },
  },
  created() {
    if (this.waterBalanceModuleEnabled) {
      this.init();
    } else {
      this.isFetched = true;
    }
  },
};
</script>
